const GRID_SIZE_MAP = [
  { minScore: 30, size: 8, walls: 'normal' },
  { minScore: 25, size: 7, walls: 'normal' },
  { minScore: 20, size: 6, walls: 'normal' },
  { minScore: 15, size: 5, walls: 'normal' },
  { minScore: 10, size: 4, walls: 'normal' },
  { minScore: 5, size: 3, walls: 'normal' },
  { minScore: 0, size: 2, walls: 'normal' }, // default fallback
];

// Returns the full configuration object
export function getGridConfig(score) {
  for (const entry of GRID_SIZE_MAP) {
    if (score >= entry.minScore) return entry;
  }
  return { size: 2, walls: 'normal' };
}

// Default export keeps backward compatibility if used elsewhere
export default function getGridSize(score) {
  return getGridConfig(score).size;
}